// Currency utilities — single source of truth for symbol lookup across the app

export const CURRENCIES = [
  { code: "INR", symbol: "₹", name: "Indian Rupee" },
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
  { code: "SAR", symbol: "﷼", name: "Saudi Riyal" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { code: "MYR", symbol: "RM", name: "Malaysian Ringgit" },
  { code: "LKR", symbol: "Rs", name: "Sri Lankan Rupee" },
  { code: "NPR", symbol: "Rs", name: "Nepalese Rupee" },
  { code: "BDT", symbol: "৳", name: "Bangladeshi Taka" },
  { code: "PKR", symbol: "Rs", name: "Pakistani Rupee" },
  { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah" },
  { code: "PHP", symbol: "₱", name: "Philippine Peso" },
  { code: "THB", symbol: "฿", name: "Thai Baht" },
  { code: "NGN", symbol: "₦", name: "Nigerian Naira" },
  { code: "KES", symbol: "KSh", name: "Kenyan Shilling" },
  { code: "ZAR", symbol: "R", name: "South African Rand" },
  { code: "BRL", symbol: "R$", name: "Brazilian Real" },
  { code: "CAD", symbol: "CA$", name: "Canadian Dollar" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
  { code: "JPY", symbol: "¥", name: "Japanese Yen" },
  { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
  { code: "KRW", symbol: "₩", name: "South Korean Won" },
];

/**
 * Returns the currency symbol for a given currency code.
 * Defaults to ₹ (INR) if not found.
 */
export function getCurrencySymbol(code) {
  const found = CURRENCIES.find((c) => c.code === code);
  return found ? found.symbol : "₹";
}

/**
 * Auto-detect currency from browser locale / timezone.
 * Used on signup to pre-select a sensible default.
 */
export function detectCurrencyFromLocale() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    const locale = navigator.language || "";

    // Timezone-based mapping (most reliable)
    if (tz.startsWith("Asia/Kolkata") || tz.startsWith("Asia/Calcutta")) return "INR";
    if (tz.startsWith("Asia/Dubai")) return "AED";
    if (tz.startsWith("Asia/Riyadh")) return "SAR";
    if (tz.startsWith("Asia/Singapore")) return "SGD";
    if (tz.startsWith("Asia/Kuala_Lumpur")) return "MYR";
    if (tz.startsWith("Asia/Colombo")) return "LKR";
    if (tz.startsWith("Asia/Kathmandu")) return "NPR";
    if (tz.startsWith("Asia/Dhaka")) return "BDT";
    if (tz.startsWith("Asia/Karachi")) return "PKR";
    if (tz.startsWith("Asia/Jakarta")) return "IDR";
    if (tz.startsWith("Asia/Manila")) return "PHP";
    if (tz.startsWith("Asia/Bangkok")) return "THB";
    if (tz.startsWith("Asia/Tokyo")) return "JPY";
    if (tz.startsWith("Asia/Shanghai") || tz.startsWith("Asia/Hong_Kong")) return "CNY";
    if (tz.startsWith("Asia/Seoul")) return "KRW";
    if (tz.startsWith("Africa/Lagos")) return "NGN";
    if (tz.startsWith("Africa/Nairobi")) return "KES";
    if (tz.startsWith("Africa/Johannesburg")) return "ZAR";
    if (tz.startsWith("America/Sao_Paulo")) return "BRL";
    if (tz.startsWith("America/Toronto") || tz.startsWith("America/Vancouver")) return "CAD";
    if (tz.startsWith("Australia/")) return "AUD";
    if (tz.startsWith("Europe/London")) return "GBP";
    if (tz.startsWith("Europe/")) return "EUR";
    if (tz.startsWith("America/")) return "USD";

    // Fallback: locale-based
    if (locale.startsWith("en-IN")) return "INR";
    if (locale.startsWith("en-US")) return "USD";
    if (locale.startsWith("en-GB")) return "GBP";
    if (locale.startsWith("en-AU")) return "AUD";
    if (locale.startsWith("en-CA")) return "CAD";
  } catch {
    // ignore
  }
  return "INR"; // safe global default
}
